const id_facility_master = {
    "": 'daftar fasilitas',
    add: 'tambah fasilitas',
    edit: 'ubah fasilitas',
    upload: 'unggah jadwal fasilitas',

    report: {
        "": 'laporan',
        facility: 'pengunaan fasilitas',
        request: 'permintaan',
    },

    label: {
        name: 'nama fasilitas'
    },

    message: {
        note_upload_title: "Catatan:",
        note_upload_1: "Hanya format Excel yang dapat diunggah.",
        note_upload_2: "Jadwal yang dapat diubah adalah fasilitas yang telah dibuat",
        note_excel: "Unduh contoh file Excel",
        note_term_title: "Ketentuan file:",
        note_term_1: "Gunakan file contoh.",
        note_term_2: "Isi sesuai dengan ketentuan yang tertulis di dalam file.",
    },

    error: {
        create: "Gagal membuat fasilitas",
        delete: "Gagal menghapus fasilitas",
        edit: "Gagal mengubah fasilitas",
        name: "Nama fasilitas tidak boleh kosong.",
        category: "Kategori fasilitas tidak boleh kosong.",
        invalid_schedule_range: "Periode waktu tidak valid.",
        schedule_required: "Lengapi periode waktu.",
    },
    success: {
        create: "Berhasil membuat fasilitas",
        delete: "Berhasil menghapus fasilitas",
        edit: "Berhasil mengubah fasilitas",
    },
}

export default id_facility_master;